export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-en-0d3043bd6a876565ca692195dba00f33.png";